export default __webpack_public_path__ + "media/images/dashboard_icons/droplet-8ffeb0eca3ad6dfa7d290ac8c72e5fa3.svg";